import Flickity from "flickity";

const NewsCategories = (slides) => {

    var slider = new Flickity(slides, {
        adaptiveHeight: false,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true
    });

}

export default NewsCategories;